module.exports = __webpack_public_path__ + "static/media/profile.c702df6e.png";